
import Vue from "vue";

export default Vue.extend({
	props: {
		to: String,
		white: Boolean,
		disabled: Boolean,
		target: String,
		tabindex: {
			type: Number,
			default: 0
		},
	},
	computed: {
		computedTabIndex():number{
			if (this.disabled){
				return -1;
			}
			return this.tabindex;
		}
	},
	methods: {
		onClick(event: Event) {
			event.preventDefault();
			if (this.disabled){
				return;
			}
			if(this.target=="_blank"){
				window.open(this.to);
				return;
			}
			if (this.to){
				this.$router.push(this.to);
			}
			this.$emit("click", event);
		}
	},
});
